import {
  ResponsiveDialogBody,
  ResponsiveDialogFooter,
} from '@/components/common/responsive-dialog'
import { Skeleton } from '@/components/sui/skeleton'

/**
 * Placeholder for AccountProfileForm while the country is still being resolved.
 *
 * The country seeds the phone's dialing code, so rendering the fields early makes
 * both of them visibly jump — first to the language's country, then to the real
 * one. Mirrors the form's own regions so nothing shifts on swap.
 */
export function AccountProfileFormSkeleton() {
  return (
    <>
      <ResponsiveDialogBody>
        <div className="space-y-4" aria-hidden="true">
          <div className="flex flex-col gap-1.5">
            <Skeleton className="h-4 w-28" />
            <div className="grid grid-cols-2 gap-3">
              {[0, 1].map((card) => (
                <div
                  key={card}
                  className="border-input flex flex-col items-start gap-2 rounded-xl border p-3 sm:p-4"
                >
                  <Skeleton className="size-9 rounded-lg" />
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="hidden h-3 w-full sm:block" />
                </div>
              ))}
            </div>
          </div>

          {[0, 1, 2].map((field) => (
            <div key={field} className="flex flex-col gap-1.5">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-9 w-full rounded-md" />
            </div>
          ))}
        </div>
      </ResponsiveDialogBody>
      <ResponsiveDialogFooter>
        <Skeleton className="h-10 w-full rounded-md" aria-hidden="true" />
      </ResponsiveDialogFooter>
    </>
  )
}
